module.exports = __webpack_public_path__ + "img/ontick-bra.1fbe0366.svg";